export default function Loader({ text }) {
  return <div className="w-full h-full flex flex-col items-center justify-center">
    <div className="rounded-md h-12 w-12 border-4 border-t-4 border-blue-500 animate-spin"></div>
    <p className="loading-text text-md m-5">{text}</p>
  </div>
}